import React, { useEffect } from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import PaymentService from '../payments/PaymentService';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { set } from 'date-fns';
import DirectoryService from 'components/app/directory/DirectoryService';
const MembershipsLandingPage = () => {
  const [products, setProducts] = React.useState();
  const [activeProduct, setActiveProduct] = React.useState();
  const [productSelected, setProductSelected] = React.useState();
  const [modalShow, setModalShow] = React.useState(false);
  const headerGenerated = useHeaderGenerator(
    'Memberships',
    ' ',
    []
  );
  const handlePurchase = (product) => {
    setProductSelected(product);
    setModalShow(true);
  };
  const handleConfirmPurchase = (product) => {
    console.log('Confirm purchase of product', product);
    PaymentService.purchaseMembership(product.identifier, product)
      .then(response => {
        window.location.href = response.url;
        setModalShow(false);
        setProductSelected(null);
      })
      .catch(error => {
        console.error('Error purchasing membership', error);
        setModalShow(false);
        setProductSelected(null);
      });
  };
  useEffect(() => {
    PaymentService.retrieveAllProductsByAccount().then((response) => {
      const updatedProducts = response.filter(product => {
        return !product.hidden || DirectoryService.isLoggedByAnyWODRole();
      });
      setProducts(updatedProducts);
    });
    const profile = DirectoryService.retrieveLoggedProfile();
    setActiveProduct(profile.membershipPlan);
    document.title = 'Memberships - WOD';
  }, []);  
  return (
    <>
     <Modal show={modalShow} onHide={() => setModalShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{productSelected?.maxClasses === 1 ? 'Purchase pass' : 'Subscribe Membership'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You have selected the following membership:</p>
          <p><strong>{productSelected?.name}</strong></p>
          <p>{productSelected?.description}</p>
          <p>Price: £{productSelected?.price} {productSelected?.currency}</p>

        </Modal.Body>
        <Modal.Footer>
        <Button variant="success" className="btn btn-sm" onClick={() => handleConfirmPurchase(productSelected)}>
            Confirm Purchase
          </Button>
          <Button variant="danger" className="btn btn-sm" onClick={() => setModalShow(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
     {headerGenerated}
     {activeProduct && (
        <Row className="g-3 mb-3">
          <Col>
            <Card>
              <Card.Body>
                <h5>Current Membership</h5>
                <p><strong>{activeProduct.name}</strong></p>
                <p>{activeProduct.description}</p>
                <p>Price: £{activeProduct.price} {activeProduct.currency}</p>
                <p>Status: {activeProduct.active ? 'Active' : 'Inactive'}</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
     {products && products.length > 0 ? (
        <Row className="g-3 mb-3">
          {products.map((product) => (
            <Col xxl={4} lg={6} key={product.identifier}>
              <div className="p-3 border bg-light">
                <h5>{product.name}</h5>
                <p>{product.description}</p>
                <p>Price: £{product.price} {product.currency}</p>
                <Button variant="success" className="btn btn-sm" onClick={() => handlePurchase(product)}>
                  {product.maxClasses === 1 ? 'Purchase' : 'Subscribe'}
                </Button>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <p>No memberships found.</p>
      )}

    </>
  );
};

export default MembershipsLandingPage;